import { getWebappLinkPrefix } from '../utils/route'

import { EMPTY_STRING } from './common'
import { DocFlowTableName } from './docFlow'

export const PAGE_PARAM_KEY = 'page'

export const PAGE_SIZE_PARAM_KEY = 'size'

export const TAB_PARAM_KEY = 'tab'

export const SUBMENU_PARAM_KEY = 'sub'

export const SUBMENU_PARAM_KEY_OLD = 'sub_menu'

export const SUBMENU_PARAM_ARCHIVE_VALUE = 'archive'

export const SUBMENU_PARAM_TRASH_VALUE = 'trash'

export const SUBMENU_PARAM_READ_VALUE = 'read'

export const SUBMENU_PARAM_UNREAD_VALUE = 'unread'

export const SUBMENU_PARAM_ACTIVE_VALUE = 'active'

export const SUBMENU_ACCOUNT_PARAM_KEY = 'account'

export const SUBMENU_OUTBOUND_COMPANY_PARAM_KEY = 'outbound'

export const FILTER_PARAM_KEY = 'filter'

export const FILTER_SCOPE_PARAM_KEY = 'scope'

export const FILTER_SCOPE_PARAM_MINE_VALUE = 'mine'

export const PAGE_DEFAULT_VALUE = 1

export const EMAIL_FOLDER_DEFAULT_VALUE = 'inbox'

export const SUBMENU_ALL_SECTION = 'all'

export const SUBMENU_DONE_SECTION = 'done'

export const SUBMENU_DEFAULT_VALUE = SUBMENU_ALL_SECTION

export const WEBAPP_ROUTE_PREFIX = 'v2'

export const WEBAPP_EMAIL_INTEGRATION_ACCOUNTS_TAB = 'integrations'

export const WEBAPP_REQUEST_FEEDBACK_TAB = 'feedback'

export const ROUTER_EXTERNAL_REDIRECT_PREFIX = 'redirect-external'

export const ROUTE_PARAM_BUILDING_GROUP_ID = 'buildingGroupId'

export const ROUTE_PARAM_BUILDING_ID = 'buildingId'

export const ROUTE_PARAM_CHATROOM_UUID = 'chatroomUuid'

export const ROUTE_PARAM_EMAIL_ACCOUNT_ID = 'accountId'

export const ROUTE_PARAM_INHABITANT_ID = 'inhabitantId'

export const ROUTE_PARAM_MAIL_UUID = 'mailUuid'

export const ROUTE_PARAM_OUTBOUND_UUID = 'outboundUuid'

export const ROUTE_PATH_LIST = {
  aboutUs: 'about-us',
  budgetPlanProfile: 'budget-plan/:budgetPlanId?',
  buildingGroupProfile: 'building-group/:buildingGroupId/:tab?',
  buildingProfile: 'building/:buildingId/:tab?',
  buildings: 'buildings',
  buildingsGroup: 'building-groups',
  calendar: 'calendar',
  chat: 'chat/:chatroomUuid',
  chats: 'messages',
  connectedRequestProfile: 'connected_request/:outboundUuid/:requestId/:tab?',
  connectedRequestThreads:
    'connected_requests/connected_request/:outboundUuid/:requestId/mails',
  dashboard: 'dashboard',
  docFlow: ':documentId',
  docFlows: 'doc-flows',
  documents: 'files',
  documentsDweller: 'dwellers-files',
  externalContact: 'external-contact/:inhabitantId/:tab?',
  faq: 'faq',
  files: 'files',
  flatProfile: 'flat/:flatId/:tab?',
  flats: 'flats',
  idwellToIdwell: 'connected_requests',
  inhabitant: 'user/:inhabitantId/:tab?',
  inhabitants: 'users',
  mailMessage: 'message/:mailUuid',
  mailMessagePrint: 'message/:mailUuid/print',
  mailMessageRaw: 'message/:mailUuid/raw',
  mails: 'mails',
  mailThread: 'thread/:mailUuid',
  mailThreadPrint: 'thread/:mailUuid/print',
  newsboard: 'newsboard',
  post: 'post/:postId',
  profile: 'profile',
  provider: 'contractor/:contractorId/:tab?',
  providers: 'contractors',
  serviceRequest: 'request/:requestId/:tab?',
  serviceRequests: 'requests',
  serviceRequestsThreads: 'requests/request/:requestId/mails',
  settings: 'settings',
  tasks: 'activities',
}

export const ROUTE_PATH_LIST_LEGACY = {
  building: 'building/:buildingId/*',
  buildingGroup: 'building-group/:buildingGroupId/*',
  buildingGroupProfile: 'group/:buildingGroupId/:tab?',
  buildingsGroup: 'groups',
  chat: 'chatroom/:chatroomUuid',
  profile: 'profile/:inhabitantId/*',
}

export const ROUTE_PATH_LIST_SEARCH_RESULTS = {
  buildings: 'search-results/buildings',
  emails: 'search-results/mails',
  flats: 'search-results/flats',
  inhabitants: 'search-results/users',
  posts: 'search-results/news',
  providers: 'search-results/contractors',
  requests: 'search-results/requests',
}

export const ROUTE_PATH_LIST_SETTINGS = {
  activityAutomation: 'automate',
  advanced: 'advanced',
  automatedDocument: 'domonda',
  calendar: 'calendar',
  colorTheme: 'color-theme',
  company: 'corporate',
  configuration: 'fields',
  emailIntegrationAccount: 'email-integration/:accountId/:tab?',
  emailIntegrationNew: 'email-integration',
  emailIntegrationOld: 'email/private',
  epostBilling: 'epost-billing',
  erpIntegration: 'integrations',
  googleDrive: 'doc-templates',
  idwellToIdwell: 'idwell-to-idwell',
  import: 'import',
  integrationProtocol: 'integration-events',
  labels: 'labels',
  manageAuth: 'permissions',
  personal: 'personal',
  processStructure: 'pipeline',
  tariffs: 'tariffs-limits',
  template: 'templates/email',
  userManagement: 'users/managers',
  workflowBot: 'workflows',
}

export const ROUTE_PATH_LIST_RENTAL_PORTAL = {
  applicant: 'applicants/applicant/:applicantId/:tab?',
  applicants: 'applicants',
  archive: 'archive',
  contracts: 'contracts',
  listing: 'listings/listing/:listingId/:tab?',
  listings: 'listings',
  overview: 'overview',
  root: 'rental-portal',
  settings: 'settings',
  settingsCriterion: 'settings/:criterionKey/:tab?',
  settingsImportLog: 'settings/integrations/import-log',
  settingsImportRun: 'settings/integrations/import-log/:runId',
  settingsIntegrations: 'settings/integrations',
  settingsRightsRoles: 'settings/rights-roles',
  settingsRulesPolicy: 'settings/rules-policy',
  viewing: 'viewings/viewing/:viewingId/:tab?',
  viewings: 'viewings',
}

export const ROUTE_PATH_LIST_AUTH = {
  about: '/about',
  login: (additionalParams = EMPTY_STRING) => `/login${additionalParams}`,
  recoverPassword: '/recover',
  registration: '/free-registration',
  setPasswordAfterRecover: '/recover/:hash',
  setPasswordAfterRegistration: '/registration/:hash',
  sharedRequest: '/shared-request/:hash',
}

export const ROUTE_PATH_LIST_DOCUMENTS = {
  directory: ({ id, path }) => `/${path}/dir/${id}`,
}

export const ROUTE_UI_SECTION_NAME = {
  aboutUs: 'about_us',
  activities: 'activities_list',
  budgetPlan: 'budget_plan_detail',
  buildingDetail: 'building_detail',
  buildingGroupProfileDetail: 'building_group_detail',
  buildingGroups: 'building_groups_list',
  buildings: 'buildings_list',
  buildingsSearch: 'buildings_search_list',
  calendar: 'calendar',
  chat: 'chat_detail',
  chats: 'chats_list',
  dashboard: 'dashboard',
  dashboardAnalytics: 'dashboard_analytics',
  docFlows: 'document_stapling_list',
  documents: 'documents_list',
  documentsDweller: 'inhabitant_documents_list',
  faq: 'faq',
  flat: 'flat_detail',
  flats: 'flats_list',
  flatsSearch: 'flats_search_list',
  idwellToIdwell: 'idwell_to_idwell_requests_list',
  idwellToIdwellRequest: 'idwell_to_idwell_request_detail',
  inhabitants: 'inhabitants_list',
  inhabitantsSearch: 'inhabitants_search_list',
  mails: 'email_threads_list',
  mailsSearch: 'email_messages_search_list',
  mailThread: 'email_thread_detail',
  newsboard: 'newsboard',
  newsboardSearch: 'newsboard_search',
  post: 'post_detail',
  providerProfileDetail: 'contractor_detail',
  providers: 'contractors_list',
  providersSearch: 'contractors_search_list',
  serviceRequest: 'request_detail',
  serviceRequests: 'requests_list',
  serviceRequestsSearch: 'requests_search_list',
  settings: 'settings_list',
  settingsAdvanced: 'settings_advanced',
  settingsCalendar: 'settings_calendar',
  settingsColorTheme: 'settings_corporate',
  settingsCompany: 'settings_corporate',
  settingsConfiguration: 'settings_configuration',
  settingsDocumentRecognition: 'settings_document_recognition',
  settingsEmailIntegration: 'settings_email_integration',
  settingsEpostBilling: 'settings_epost_billing',
  settingsErpIntegration: 'settings_erp_integration',
  settingsGoogleDrive: 'settings_google_drive',
  settingsIntegrationProtocol: 'settings_integration_protocol',
  settingsLabels: 'labels_list',
  settingsManageAuth: 'settings_authorizations',
  settingsPersonal: 'settings_personal',
  settingsTariffsLimits: 'settings_tariffs_limits',
  userProfileDetail: 'user_profile_detail',
}

export const ROUTE_UI_SECTION_NAME_RENTAL_PORTAL = {
  applicants: 'rental_portal_applicants',
  archive: 'rental_portal_archive',
  contracts: 'rental_portal_contracts',
  listings: 'rental_portal_listings',
  overview: 'rental_portal_overview',
  root: 'rental_portal',
  settingsMatching: 'rental_portal_settings_matching',
  viewings: 'rental_portal_viewings',
}

export const SEARCH_RESULTS_QUERY_PARAM_KEY = 'query'

export const SEARCH_RESULTS_REQUESTS_QUERY_PARAM_KEY = 'search_query'

export const WEBAPP_SEARCH_ENTITY = {
  buildings: 'buildings',
  flats: 'flats',
  inhabitants: 'users',
  mails: 'mails',
  newsboard: 'newsbands',
  providers: 'contractors',
  serviceRequests: 'requests',
}

export const URL_ALIASES = {
  [DocFlowTableName.Combining]: '/doc-flows/',

  [DocFlowTableName.MappingResult]: '/doc-flows/',

  [DocFlowTableName.Result]: '/doc-flows/',
  [DocFlowTableName.Sending]: '/doc-flows/',
  activities: '/activities/',
  'building-groups': '/building-groups/',
  buildings: '/buildings/',
  'buildings-search': '/search-results/buildings/',
  chats: '/messages/',
  contractors: '/contractors/',
  'document-staplings': '/doc-flows/',
  documents: '/files/',
  'email-messages': '/mails/',
  'email-threads': '/mails/',
  'epost-billing-transactions': '/settings/epost-billing/',
  faq: '/faq/',
  flats: '/flats/',
  'flats-search': '/search-results/flats/',
  'idwell-to-idwell': '/connected_requests/',
  inhabitants: '/users/',
  labels: '/settings/labels/',
  news: '/newsboard/',
  'news-search': '/search-results/news/',
  'rental-portal-listings': '/rental-portal/listings/',
  'request-threads': '/requests/request/',
  requests: '/requests/',
  'requests-search': '/search-results/requests/',
}

export const SEARCH_RESULTS_QUERY_PARAM_BY_TABLE = {
  'buildings-search': SEARCH_RESULTS_QUERY_PARAM_KEY,
  'flats-search': SEARCH_RESULTS_QUERY_PARAM_KEY,
  'news-search': SEARCH_RESULTS_REQUESTS_QUERY_PARAM_KEY,
  'requests-search': SEARCH_RESULTS_REQUESTS_QUERY_PARAM_KEY,
}

export const BUDGET_PLAN_REQUEST_ID_QUERY_PARAM = 'requestId'

export const PROFILE_ROUTE_NAMES = {
  budgetPlan: id => getWebappLinkPrefix(`budget-plan/${id}/`),
  budgetPlanCreate: requestId =>
    getWebappLinkPrefix(
      `budget-plan/?${BUDGET_PLAN_REQUEST_ID_QUERY_PARAM}=${requestId}`
    ),
  budgetPlanCreateNG: requestId =>
    `/budget-plan?${BUDGET_PLAN_REQUEST_ID_QUERY_PARAM}=${requestId}`,
  budgetPlanProfileNG: id => `/budget-plan/${id}`,
  building: id => getWebappLinkPrefix(`building/${id}`),
  buildingGroup: id => getWebappLinkPrefix(`building-group/${id}/`),
  buildingGroupProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/building-groups/building-group/${id}${additionalParams}`,
  buildingProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/buildings/building/${id}${additionalParams}`,
  chat: uuid => getWebappLinkPrefix(`chatroom/${uuid}`),
  chatProfileNG: uuid => `/messages/chat/${uuid}`,
  connectedRequest: (id, outboundUuid) =>
    getWebappLinkPrefix(`connected_request/${outboundUuid}/${id}`),
  connectedRequestProfileNG: ({
    additionalParams = EMPTY_STRING,
    id,
    outboundUuid,
  }) =>
    `/connected_requests/connected_request/${outboundUuid}/${id}${additionalParams}`,
  connectedRequestThreadMessagePrint: ({
    additionalParams = EMPTY_STRING,
    id,
    outboundUuid,
    requestId,
  }) =>
    `/connected_requests/connected_request/${outboundUuid}/${requestId}/mails/message/${id}/print/${additionalParams}`,
  connectedRequestThreadMessageRaw: ({
    additionalParams = EMPTY_STRING,
    id,
    outboundUuid,
    requestId,
  }) =>
    `/connected_requests/connected_request/${outboundUuid}/${requestId}/mails/message/${id}/raw/${additionalParams}`,
  connectedRequestThreadPrint: ({
    additionalParams = EMPTY_STRING,
    id,
    outboundUuid,
    requestId,
  }) =>
    `/connected_requests/connected_request/${outboundUuid}/${requestId}/mails/thread/${id}/print/${additionalParams}`,
  docFlow: id => `${URL_ALIASES['document-staplings']}${id}`,
  email: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`message/${id}${additionalParams}`),
  emailMessage: ({ additionalParams = EMPTY_STRING, id }) =>
    `/mails/message/${id}${additionalParams}`,
  emailMessagePrint: ({ additionalParams = EMPTY_STRING, id }) =>
    `/mails/message/${id}/print/${additionalParams}`,
  emailMessageRaw: ({ additionalParams = EMPTY_STRING, id }) =>
    `/mails/message/${id}/raw/${additionalParams}`,
  emailThread: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`mail/${id}${additionalParams}`),
  emailThreadNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/mails/thread/${id}${additionalParams}`,
  emailThreadPrint: ({ additionalParams = EMPTY_STRING, id }) =>
    `/mails/thread/${id}/print/${additionalParams}`,
  externalContactProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/users/external-contact/${id}${additionalParams}`,
  externalContacts: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`external-contact/${id}/contacts${additionalParams}`),

  flat: id => getWebappLinkPrefix(`flat/${id}`),
  flatProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/flats/flat/${id}${additionalParams}`,
  folder: id => `/files/dir/${id}`,
  folderDweller: id => `/dwellers-files/dir/${id}`,
  inhabitant: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`profile/${id}${additionalParams}`),
  post: id => getWebappLinkPrefix(`post/${id}`),
  postProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/post/${id}${additionalParams}`,
  provider: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`contractor/${id}${additionalParams}`),
  providerProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/contractors/contractor/${id}${additionalParams}`,
  rentalPortalApplicantProfile: ({ additionalParams = EMPTY_STRING, id }) =>
    `/rental-portal/applicants/applicant/${id}${additionalParams}`,
  rentalPortalListingProfile: ({ additionalParams = EMPTY_STRING, id }) =>
    `/rental-portal/listings/listing/${id}${additionalParams}`,
  rentalPortalViewingProfile: ({ additionalParams = EMPTY_STRING, id }) =>
    `/rental-portal/viewings/viewing/${id}${additionalParams}`,
  request: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`request/${id}${additionalParams}`),
  requestProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/requests/request/${id}${additionalParams}`,
  requestTask: ({ additionalParams = EMPTY_STRING, id }) =>
    getWebappLinkPrefix(`request/${id}/chats/activitiy${additionalParams}`),
  requestThreadMessagePrint: ({
    additionalParams = EMPTY_STRING,
    id,
    requestId,
  }) =>
    `/requests/request/${requestId}/mails/message/${id}/print/${additionalParams}`,
  requestThreadMessageRaw: ({
    additionalParams = EMPTY_STRING,
    id,
    requestId,
  }) =>
    `/requests/request/${requestId}/mails/message/${id}/raw/${additionalParams}`,
  requestThreadPrint: ({ additionalParams = EMPTY_STRING, id, requestId }) =>
    `/requests/request/${requestId}/mails/thread/${id}/print/${additionalParams}`,
  sharedRequest: hash => getWebappLinkPrefix(`shared-request/${hash}`),
  userProfileNG: ({ additionalParams = EMPTY_STRING, id }) =>
    `/users/user/${id}${additionalParams}`,
}

export const EMAILS_SECTION_SUB_VALUES = {
  archive: SUBMENU_PARAM_ARCHIVE_VALUE,
  important: 'important',
  inbox: 'inbox',
  sent: 'sent',
  trash: SUBMENU_PARAM_TRASH_VALUE,
}

export const LEGACY_SUBMENU_PARAM_REPLACERS = {
  soft_archived: SUBMENU_PARAM_ARCHIVE_VALUE,
  unviewed: 'unread',
  viewed: 'read',
}

export const UTM_PARAMETER_PREFIX = 'utm_'

export const SEARCH_USER_PARAM_EMAIL = 'email'

export const SEARCH_USER_PARAM_PHONE = 'phone'

export const UTM_EMAIL_PARAMETER = 'email'

export const UTM_REQUEST_PARAMETER = 'service_request'

export const UTM_TASK_PARAMETER = 'activity'

export const UTM_HOME_PARAMETER = 'home'

export const LIST_ROUTE_NAMES = {
  emails: ({ additionalParams = EMPTY_STRING }) => `mails/${additionalParams}`,
  externalContacts: () =>
    getWebappLinkPrefix('settings/users/external-contacts', true),
  searchResultsBuildings: ({ archived = false, query }) =>
    `/search-results/buildings/?query=${encodeURIComponent(query)}&archived=${archived}`,
  searchResultsEmails: ({ archived = false, query }) =>
    `/search-results/mails/?query=${encodeURIComponent(query)}&archived=${archived}`,
  searchResultsFlats: ({ archived = false, query }) =>
    `/search-results/flats/?query=${encodeURIComponent(query)}&archived=${archived}`,
  searchResultsInhabitants: ({ archived = false, query }) =>
    `/search-results/users/?query=${encodeURIComponent(query)}&archived=${archived}`,
  searchResultsPosts: ({ query }) =>
    `/search-results/news/?search_query=${encodeURIComponent(query)}`,
  searchResultsProviders: ({ archived = false, query }) =>
    `/search-results/contractors/?query=${encodeURIComponent(query)}&archived=${archived}`,
  searchResultsRequests: ({ archived = false, query }) =>
    `/search-results/requests/?search_query=${encodeURIComponent(query)}&archived=${archived}`,
}
